export const Reports = () => <div>Reports is comming</div>;
